window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.querySuggestions = `
    <style>
        p {
            font-family: 'Open Sans', sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: clamp(14px, 1.4vw, 16px);
            line-height: clamp(24px, 1.4vw, 29px);
            letter-spacing: .15px;
            color: #666;
        }

        .query-suggestions {
            margin: 0 0 8px 0;
        }

        .query-suggestions__link {
            font-style: italic;            
            text-decoration: underline;
        }

        .query-suggestions__link:hover {            
            color: #e6007e;
        }
    </style>    
    <div class="query-suggestions">
        <p>{{query-suggestions querySuggestions}}</p>
    </div>    
`;
